import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/NewsCard.css';

const NewsCard = ({ news }) => {
  const navigate = useNavigate();
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  // Extraire l'URL de l'image
  const imageUrl = news.image_une 
    ? `https://cdn.achat-or-et-argent.fr/ressources_v4/images/news/${news.image_une}`
    : 'https://via.placeholder.com/400x250?text=Actualité';

  // Générer l'URL SEO pour le site public
  const publicUrl = news.label_url_fr 
    ? `https://www.achat-or-et-argent.fr/cours-de-l-or-et-argent-${news.id}-${news.label_url_fr}`
    : `https://www.achat-or-et-argent.fr/actualites/${news.id}`;

  return (
    <div className="news-card">
      <div className="news-card-image">
        <img src={imageUrl} alt={news.label || news.titre_fr} onError={(e) => {
          e.target.src = 'https://via.placeholder.com/400x250?text=Actualité';
        }} />
      </div>
      <div className="news-card-content">
        <div className="news-card-date">
          📅 {formatDate(news.dateposted)}
        </div>
        <h3 className="news-card-title">{news.label || news.titre_fr}</h3>
        <p className="news-card-resume">{news.resume_fr}</p>
        <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
          <button 
            onClick={(e) => {
              e.stopPropagation();
              navigate(`/news/${news.id}`);
            }}
            className="news-card-link"
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: 0,
              font: 'inherit',
              flex: 1
            }}
          >
            📄 Voir dans le BO →
          </button>
          <a 
            href={publicUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="news-card-link"
            onClick={(e) => e.stopPropagation()}
            style={{
              flex: 1,
              textAlign: 'center'
            }}
          >
            🌐 Site public →
          </a>
        </div>
      </div>
    </div>
  );
};

export default NewsCard;

